import { render, staticRenderFns } from "./CustomMultiselect.vue?vue&type=template&id=2f4535cc&"
import script from "./CustomMultiselect.vue?vue&type=script&lang=js&"
export * from "./CustomMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./CustomMultiselect.vue?vue&type=style&index=0&id=2f4535cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports